<script lang="ts" setup>
  import { onMounted, ref } from 'vue';
  import Splide from '@splidejs/splide';
  
  const splideEl = ref<HTMLElement | null>(null);  
  
  onMounted(() => {
      if (splideEl.value) {
        setTimeout(() => {
          const splide = new Splide(splideEl.value, {
              type   : 'loop',
              padding: { left: '0rem', right: '4rem' },
              pagination: false,
              arrows: false,
              lazyLoad: 'nearby',
              autoplay: false,
          });
      
          splide.mount();
        }, 100);
      }
  });

  const props = defineProps<{
      imageLink: {
        title: string,
        link: {
          url: string,
          title: string
        },
        image: {
          node: {
            mediaItemUrl: string,
            srcSet: string,
            title: string,
            uri: string
          }
        }
      }[];
  }>();
</script>
<template>
  <div class="container-xl image-link-div d-none d-md-block">
    <div class="bg-dark d-flex p-3 rounded-xl">
      <template v-for="imageObj in props?.imageLink">
          <a :href="imageObj?.link?.url" class="image-link col-md-4">
            <div class="p-3 link-item w-100 h-100">
                <h5 class="text-uppercase text-secondary title">{{ imageObj?.title }}</h5>
                <NuxtImg
                  v-if="imageObj?.image?.node?.mediaItemUrl"
                  class="h-100 w-100 object-fit-cover rounded-3"
                  loading="lazy"
                  :src="imageObj?.image?.node?.mediaItemUrl"
                  :alt="imageObj?.image?.node?.title"
                  format="webp"
                  :quality="80"
                  :srcset="imageObj?.image?.node?.srcSet"/>
            </div>
          </a>
      </template>
    </div>
  </div>
  <div class="container-fluid d-md-none d-block mobile-slider pe-0">
    <div class="container-xl pe-0">
      <div class="bg-dark rounded-lg-start pe-0">
        <div class="splide ps-4 pe-0" ref="splideEl">
          <div class="splide__track">
              <ul class="splide__list">
                <li
                  v-for="(slide, i) in props?.imageLink"
                  :key="i"
                  class="splide__slide"
                >
                  <div class="slide-wrapper image-link-group">
                    <a :href="slide?.link?.url" class="">
                      <div class="p-4 link-item w-100 h-100 position-relative">
                          <h6 class="text-uppercase text-secondary title">{{ slide?.title }}</h6>
                          <NuxtImg
                            v-if="slide?.image?.node?.mediaItemUrl"
                            class="w-100 object-fit-cover rounded-5"
                            loading="lazy"
                            :src="slide?.image?.node?.mediaItemUrl"
                            :alt="slide?.image?.node?.title" format="webp"
                            :srcset="slide?.image?.node?.srcSet"
                            :quality="80"
                            sizes="sm:202px"/>
                      </div>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>